const _ = require('../../lodash');

var IdentityMap = function (bus) {
   var _tracked = {};
   var _valid = true;
   var _invalidReason = null;

   return {
      trackObject: trackObject,
      trackObjects: trackObjects,
      getTrackedObject: function (predicate) {
         assertValid();
         var list = Object.keys(_tracked).map((k) => _tracked[k]);
         return _.find(list, (x) => {
            return predicate(x);
         });
      },
      getTrackedObjects: function () {
         assertValid();
         return Object.keys(_tracked).map((k) => _tracked[k]);
      },
      getChangedObjects: function () {
         assertValid();
         return _.filter(
            Object.keys(_tracked).map((k) => _tracked[k]),
            (x) => {
               return x.hasChanged();
            }
         );
      },
      invalidate: invalidate,
      isValid: function () {
         return _valid;
      },
      assertValid: assertValid
   };

   function trackObject(o) {
      assertValid();
      if (o == null) return null;
      var objects = [];
      objects.push(o);
      return trackObjects(objects)[0];
   }

   function trackObjects(objects) {
      assertValid();
      var results = [];

      for (var index = 0, max = objects.length; index < max; index++) {
         var o = objects[index];

         if (typeof _tracked[o.id] === 'undefined') {
            o.subscribe(bus.dispatch);
            _tracked[o.id] = o;
         }
      }

      for (var index2 = 0, max2 = objects.length; index2 < max2; index2++) {
         var o2 = objects[index2];

         if (typeof _tracked[o2.id] !== 'undefined') {
            results.push(o2);
         }
      }

      return results;
   }

   function invalidate(reason) {
      if (!_valid) return;
      _valid = false;
      _invalidReason = reason || 'IDENTITY_MAP_INVALIDATED';
      _tracked = {};
   }

   function assertValid() {
      if (!_valid) {
         throw new Error('IdentityMap is invalid: ' + _invalidReason);
      }
   }
};

module.exports = IdentityMap;
